<template>
  <div class="" filter-color="white">
    <div class="row mt-2">
      <div class="col-12">
        <i class="bi bi-arrow-left ml-3 goBackArrow" v-on:click="goBack()"></i>
      </div>
    </div>

    <div class="content text-black pt-3">
      <div class="centerTimePicker text-center pt-4 px-lg-5">
        <div class="row mb-4 mx-3">
          <div class="col-12">
            <h2 class="title pt-0 mobile-title">
              {{ timeline["o:title"] }}
            </h2>
            <h3 class="text-black">
              {{ timeline["geo:Titolo_it"][0]["@value"] }}
            </h3>
            <h4 class="description">
              <b> {{ timeline["dcterms:description"][0]["@value"] }}</b>
            </h4>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div id="first-section1">
              <div class="container">
                <div class="row">
                  <div class="triangle"></div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <section id="cd-timeline" class="cd-container">
                      <div
                        v-for="(event, index) in timeline.events"
                        :key="index"
                        class="cd-timeline-block"
                      >
                        <div class="cd-timeline-img cd-picture">
                          <i class="fa-solid fa-calendar-clock"></i>
                        </div>

                        <div
                          class="
                            cd-timeline-content
                            service-box-content
                            pt-0
                            px-0
                          "
                        >
                          <div
                            class="
                              row
                              postcardpercorsi
                              timeline
                              orange
                              overflow-hidden
                            "
                          >
                            <div class="col-12">
                              <div v-if="event.image !== null" class="row mb-4">
                                <div class="col-12 px-0">
                                  <a class="postcardpercorsi__img_link">
                                    <img
                                      :src="event.image"
                                      v-img="{ group: getGroupName(event) }"
                                      :alt="event['geo:Titolo_it'][0]['@value']"
                                      style="width: 100%"
                                      class="
                                        w-100
                                        postcardtimeline__img
                                        px-0
                                        mx-0
                                        rounded-top
                                      "
                                    />
                                  </a>
                                </div>
                              </div>

                              <div class="row mt-3">
                                <div class="col-12 mb-3 text-center">
                                  <h3 class="mb-1">
                                    {{ event["geo:Data"][0]["@value"] }}
                                  </h3>
                                  <div
                                    class="
                                      postcardtimeline__bar
                                      margin-auto
                                      d-inline-block
                                    "
                                  ></div>

                                  <h2 class="mb-1">
                                    {{ event["geo:Titolo_it"][0]["@value"] }}
                                  </h2>
                                  <p class="px-4">
                                    {{
                                      event["dcterms:description"][0]["@value"]
                                    }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--<iframe style="display:block; width:100%; height:100vh;" seamless frameborder="0" scrolling="yes"
            src="https://docs.google.com/spreadsheets/d/e/2PACX-1vSIXLqLm6L5PbmO0b6Y5dNEPUoN9UpKx3rW-MWvUDjHzr14ytcqDg_H_2ZZhve2isAaVxMAEekby0QE/pubchart?oid=1795973304&amp;format=interactive"></iframe>-->
  </div>
</template>
<script>
import store from "../store";
import Vuex from "vuex";
import router from "../router";

import { FormGroupInput } from "@/components";

const Common = require("@/Common.vue").default;

export default {
  name: "timeline-page",
  bodyClass: "timeline-page",
  components: {
    [FormGroupInput.name]: FormGroupInput,
  },

  data() {
    return {
      timelinesReady: false,
    };
  },

  beforeMount() {
    var timelineIndex = this.$route.params.index;

    this.timeline = store.state.timelines[timelineIndex];

    this.timeline.events.sort((a, b) =>
      a["geo:Data"][0]["@value"] > b["geo:Data"][0]["@value"]
        ? 1
        : b["geo:Data"][0]["@value"] > a["geo:Data"][0]["@value"]
        ? -1
        : 0
    );
  },

  computed: {
    ...Vuex.mapGetters([]),
  },

  methods: {
    goBack() {
      router.go(-1);
    },
    getGroupName(event) {
      return event["geo:Titolo_it"][0]["@value"];
    },
    getCorrectTimelines() {
      var timelines = [...Array(store.state.timelines.length)].map((x) => 0);

      Array.prototype.forEach.call(store.state.timelines, (i, index) => {
        var timeline = [];

        Array.prototype.forEach.call(i.events, (event) => {
          var date;

          if (event["geo:Data"][0]["@value"].length === 4) {
            date = new Date(event["geo:Data"][0]["@value"]);
          } else if (event["geo:Data"][0]["@value"].length > 4) {
            const [day, month, year] =
              event["geo:Data"][0]["@value"].split("/");
            date = new Date(year, month, day);
          }

          var description = event["dcterms:description"][0]["@value"];

          var e = {
            from: date,
            year: date.getFullYear(),
            title: event["geo:Titolo_it"][0]["@value"],
            showDayAndMonth: true,
            description: description,
          };

          if (event["media"] !== undefined && event["media"].length > 0) {
            e.image = event["media"][0]["o:thumbnail_urls"]["large"];
          } else {
            e.image = null;
          }

          timeline.push(e);
        });

        timelines[index] = timeline;
      });

      this.timelinesReady = true;

      return timelines;
    },
  },
};
</script>
<style>
</style>
